// The Deep/Sharp chapter list (.chapter-index__row) reuses the report_chapter
// card_summary render, so only the image and text sit inside the actual
// <a class="card-summary__card">; the number badge and arrow affordance are
// siblings outside it. Clicking anywhere else in the row proxies through to
// that link. Keyboard users still reach the real anchor directly via Tab.
jQuery(function ($) {
  $('.chapter-index__row').each(function () {
    const $row = $(this);
    const $link = $row.find('.card-summary__card').first();

    if (!$link.length) {
      return;
    }

    $row.on('click', (event) => {
      if ($(event.target).closest('a').length) {
        return;
      }

      window.location.assign($link.attr('href'));
    });
  });
});
